import React from 'react'
import Title from './title-slide/edit-dialog/edit-dialog.container'
import Exemplar from './exemplar-slide/edit-dialog/edit-dialog.container'
import Exercise from './exercise-slide/edit-dialog/edit-dialog.container'
import Image from './image-slide/edit-dialog/edit-dialog.container'
import LO from './lesson-overview/edit-dialog/edit-dialog.container'
import Link from './link-slide/edit-dialog/edit-dialog'
import SC from './success-criteria-slide/edit-dialog/edit-dialog.container'
import Text from './text-slide/edit-dialog/edit-dialog.container'
import Video from './video-slide/edit-dialog/edit-dialog.container'
import WordBank from './word-bank/edit-dialog/edit-dialog.container'

export const EditSlideDialogs = () => {
  return (
    <>
      <Text />
      <Image />
      <Video />
      <Link />
      <WordBank />
      <Exercise />
      <SC />
      <Title />
      <Exemplar />
      <LO />
    </>
  )
}
